import s from './ServiceNotification.module.sass';

import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslator } from '$hooks';
import { AttachType, MessageModel } from '$store/models';
import { imActions } from '$store/im';
import router from '$navigation/router';
import { CHAT, IM } from '$shared/constants/pages';

export const ServiceNotification: FC<{ message: MessageModel }> = ({ message }) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const attach = message.attachments?.[0];

  const handleClick = useCallback(() => {
    if (attach?.type === AttachType.SERVICE_NOTIFICATION && attach.serviceNotification) {
      const { serviceId, fromUserId } = attach.serviceNotification;
      dispatch(imActions.setAsPeerId(serviceId));
      router.navigate(CHAT, { peerId: fromUserId });
    } else if (attach?.type === AttachType.SERVICE_SUMMARY && attach.serviceSummary) {
      const { serviceId } = attach.serviceSummary;
      dispatch(imActions.setAsPeerId(serviceId));
      router.navigate(IM);
    }
  }, [dispatch, attach]);

  return (
    <div className={s.wrap}>
      <div className={s.in} onClick={handleClick}>
        <div className={s.text}>{message.text}</div>
        <div className={s.action}>{t('service_notification_open')}</div>
      </div>
    </div>
  );
};
